import React, { useEffect, useMemo, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaEye } from "react-icons/fa";
import { LuEye } from "react-icons/lu";
import { useNavigate, useLocation } from "react-router-dom";
import DoerProgressModal from "../components/DoerProgressModal";

// ✅ Set your API base here (Cloud Run URL)
const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";

function fmtDateInput(d) {
  const dt = new Date(d);
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function safeStr(v) {
  if (v === null || v === undefined) return "";
  return String(v);
}
function formatPenaltyReason(text) {
  if (!text) return "No reason available";

  const raw = String(text);

  // ✅ For HelpTicket / Inward / Outward
  if (!raw.includes("Step:") || !raw.includes("FMS:")) {
    return raw;
  }

  const entries = raw
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);

  const grouped = {};

  entries.forEach(entry => {
    const stepMatch = entry.match(/Step:\s*(T\d+)/i);
    const fmsMatch = entry.match(/FMS:\s*([^,]+)/i);

    if (!stepMatch || !fmsMatch) return;

    const step = stepMatch[1];
    const fms = fmsMatch[1].trim();

    if (!grouped[fms]) {
      grouped[fms] = new Set();
    }

    grouped[fms].add(step);
  });

  return Object.entries(grouped).map(([fms, steps]) => (
    <div key={fms} style={{ marginBottom: 8 }}>
      <b>FMS:</b> {fms} | <b>Step:</b> {Array.from(steps).sort().join(", ")}
    </div>
  ));
}

function getIstNowParts() {
  const now = new Date();

  const dateStr = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);

  const timeStr = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(now);

  const weekday = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    weekday: "short",
  }).format(now);

  const [hour, minute, second] = timeStr.split(":").map(Number);

  return { dateStr, timeStr, weekday, hour, minute, second };
}

function ymdFromDateObj(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
function getPreviousWeekRange() {
  const now = new Date();

  // current weekday (0=Sun,1=Mon...)
  const day = now.getDay();

  // current week Monday
  const currentMonday = new Date(now);

  const diffToMonday = day === 0 ? -6 : 1 - day;

  currentMonday.setDate(now.getDate() + diffToMonday);

  // previous week Monday
  const prevMonday = new Date(currentMonday);
  prevMonday.setDate(currentMonday.getDate() - 7);

  // previous week Saturday
  const prevSaturday = new Date(prevMonday);
  prevSaturday.setDate(prevMonday.getDate() + 5);

  return {
    start: fmtDateInput(prevMonday),
    end: fmtDateInput(prevSaturday),
  };
}
function getPrevious2ValidDatesIst() {
  const { dateStr } = getIstNowParts();
  const base = new Date(`${dateStr}T00:00:00`);
  const out = [];

  for (let i = 1; out.length < 2 && i <= 10; i++) {
    const d = new Date(base);
    d.setDate(base.getDate() - i);

    // skip Sunday only
    if (d.getDay() === 0) continue;

    out.push(ymdFromDateObj(d));
  }

  return out;
}



// function isWithinSubmitWindowIst() {
//   const { hour, minute } = getIstNowParts();
//   const mins = hour * 60 + minute;
//   return mins >= 8 * 60 && mins < 12 * 60;
// }


function isWithinSubmitWindowIst() {
  const { hour, minute } = getIstNowParts();
  const mins = hour * 60 + minute;
  return mins >= 8 * 60 && mins < 19 * 60; // ✅ 7 PM
}



function renderPcRemarkCell(r, openPcRemarkPopup) {
  const total = Number(r.Total_Average_Score || 0);
  const final = Number(r.Final_Score || 0);
  const remark = r.PC_Remark;

  if (remark) return <span>{remark}</span>;

  if (total <= -20 || final <= -20) {
    return (
      <button className="btnGhost" onClick={() => openPcRemarkPopup(r)}>
        Add Remark
      </button>
    );
  }

  return "—";
}
function renderDoerCommitmentCell(r, openCommitmentPopup) {
  const total = Number(r.Total_Average_Score || 0);
  const final = Number(r.Final_Score || 0);
  const commitment = r.Doer_Commitment;

  if (commitment) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: "120px"
      }}>
        <span style={{ fontWeight: 600 }}>
          {r.Doer_Commitment_Score ?? "-"}
        </span>
        <span className="mutedSmall">{commitment}</span>
      </div>
    );
  }

  if (total <= -20 || final <= -20) {
    return (
      <button className="btnGhost" onClick={() => openCommitmentPopup(r)}>
        Add Commitment
      </button>
    );
  }

  return "—";
}



// ✅ Your score formula on TOTAL row
function calcScoreFromCounts(planned, done, notDone, doneDelay) {
  planned = Number(planned || 0);
  done = Number(done || 0);
  notDone = Number(notDone || 0);
  doneDelay = Number(doneDelay || 0);

  const notDoneScore = planned ? (notDone / planned) * -100 : 0;
  const doneDelayScore = done ? (doneDelay / done) * -100 : 0;

  const nd = Math.round(notDoneScore * 100) / 100;
  const dd = Math.round(doneDelayScore * 100) / 100;

  let avg;
  if (nd === -100 && dd === 0) avg = -100;
  else avg = (notDoneScore + doneDelayScore) / 2;

  return {
    TotalNotDone_Score: Math.round(notDoneScore * 100) / 100,
    TotalNotDoneOnTime_Score: Math.round(doneDelayScore * 100) / 100,
    Total_Average_Score: Math.round(avg * 100) / 100,
  };
}

function groupByDoer(rows) {
  const map = new Map();

  rows.forEach((r) => {
    const email = safeStr(r.User_Emails || r.Doer_Email || "").toLowerCase();
    const name = safeStr(r.User_Name || r.Doer_Name || "");
    const key = email || name || safeStr(r.__rowKey);

    if (!map.has(key)) map.set(key, []);
    map.get(key).push(r);
  });

  // sort inside group by Department then Process
  for (const arr of map.values()) {
    arr.sort((a, b) => {
      const d = safeStr(a.Department).localeCompare(safeStr(b.Department));
      if (d !== 0) return d;
      return safeStr(a.Process_Name).localeCompare(safeStr(b.Process_Name));
    });
  }

  return Array.from(map.entries()).map(([key, list]) => ({ key, list }));
}


// export default function ErrorCorrection({ activeDoerEmail, mode = "pc" }) {
  export default function ErrorCorrection({ activeDoerEmail }) {

      const isRuchiraUser =
    String(activeDoerEmail || "")
      .trim()
      .toLowerCase() === "ruchiraitte@geplcapital.com";

    const [pcRemarkOpen, setPcRemarkOpen] = useState(false);
const [pcRemarkText, setPcRemarkText] = useState("");
const [selectedRow, setSelectedRow] = useState(null);

const [commitmentOpen, setCommitmentOpen] = useState(false);
const [commitmentScore, setCommitmentScore] = useState("");
const [commitmentText, setCommitmentText] = useState("");
const [pcRemarkSaving, setPcRemarkSaving] = useState(false);
const [commitmentSaving, setCommitmentSaving] = useState(false);



    const [isReady, setIsReady] = useState(false);
  const [department, setDepartment] = useState("All");
  const [depts, setDepts] = useState([]);
  const [pageMode, setPageMode] = useState("pc");

  const [startDate, setStartDate] = useState(() => fmtDateInput(new Date()));
  const [endDate, setEndDate] = useState(() => fmtDateInput(new Date()));
  const [usePreviousWeek, setUsePreviousWeek] = useState(false);

  const [progressOpen, setProgressOpen] = useState(false);
const [progressEmail, setProgressEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
useEffect(() => {
  const params = new URLSearchParams(location.search);

  const modeParam = params.get("mode");
  const dateParam = params.get("date");

  if (modeParam) {
    setPageMode(modeParam);
  }

  if (modeParam === "hod" && dateParam) {
    setStartDate(dateParam);
    setEndDate(dateParam);
  }

  setIsReady(true); // ✅ mark ready AFTER params applied
}, [location.search]);

// Only auto-fetch ONCE, when the page first becomes ready (covers the
// ?mode=hod&date=... URL-param case, which sets a specific date on
// load). After that, changing Start/End date inputs (or toggling
// "Previous Week") no longer auto-fetches — the user must click Load.
const hasInitialFetchRef = useRef(false);

useEffect(() => {
  if (!isReady) return;
  if (!startDate || !endDate) return;
  if (hasInitialFetchRef.current) return;

  hasInitialFetchRef.current = true;
  fetchLive();
}, [isReady, startDate, endDate]);

  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState([]);
  const [doerStatusMap, setDoerStatusMap] = useState({});
  const [err, setErr] = useState("");

  // details modal
  const [modalOpen, setModalOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [gridLoading, setGridLoading] = useState(false);
  const [gridErr, setGridErr] = useState("");
  const [gridData, setGridData] = useState(null);

  const [search, setSearch] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
const [bulkMsg, setBulkMsg] = useState("");


  const [istClock, setIstClock] = useState(() => getIstNowParts());
const [allowedDates, setAllowedDates] = useState(() => getPrevious2ValidDatesIst());

// ====================== ✅ SUBMIT POPUP STATE ======================
const [submitOpen, setSubmitOpen] = useState(false);
const [submitBusy, setSubmitBusy] = useState(false);
const [submitMsg, setSubmitMsg] = useState("");

const [submitCtx, setSubmitCtx] = useState(null);

const [penaltyPopupOpen, setPenaltyPopupOpen] = useState(false);
const [penaltyReason, setPenaltyReason] = useState("");
const [selectedHrDept, setSelectedHrDept] = useState("");
const [scoreFilter, setScoreFilter] = useState(""); // "", "above", "below"
const [uidPopupOpen, setUidPopupOpen] = useState(false);
const [uidList, setUidList] = useState([]);

function openUidPopup(uids) {
  setUidList(uids);
  setUidPopupOpen(true);
}
// submitCtx = {
//   department,
//   processKey,      // unique (rowKey||process/indent)
//   gridDate,
//   doerName,
//   doerEmail,
//   displayName,     // process name or indent number
//   taskOptions: []  // checkbox items (Step codes)
// }

const [selectedTasks, setSelectedTasks] = useState(new Set());
const [remarksType, setRemarksType] = useState("HR Mantra issue");
const [remarksText, setRemarksText] = useState("");

function openSubmitPopup(ctx) {
  const canSubmit = isWithinSubmitWindowIst();
  const validDates = getPrevious2ValidDatesIst();
  const ctxDate = String(ctx?.gridDate || "").slice(0, 10);

  if (!canSubmit) {
    setErr("Correction form can be submitted only between 08:00 AM and 12:00 PM IST.");
    return;
  }

  if (!validDates.includes(ctxDate)) {
    setErr(`Correction form can be submitted only for previous 2 valid dates: ${validDates.join(", ")}`);
    return;
  }

  setSubmitMsg("");
  setSubmitCtx(ctx);
  setSelectedTasks(new Set());
  setRemarksType("HR Mantra issue");
  setRemarksText("");
  setSubmitOpen(true);
}
function closeSubmitPopup() {
  setSubmitOpen(false);
  setSubmitCtx(null);
  setSelectedTasks(new Set());
  setSubmitBusy(false);
  setSubmitMsg("");
}


function openPcRemarkPopup(row) {
  setSelectedRow(row);
  setPcRemarkText("");
  setPcRemarkOpen(true);
}

function openCommitmentPopup(row) {
  setSelectedRow(row);
  setCommitmentScore("");
  setCommitmentText("");
  setCommitmentOpen(true);
}

async function savePcRemark() {
  if (!selectedRow) return;

  try {
     setPcRemarkSaving(true);  

    const deptFinal =
  selectedRow.Process_Name ||
  selectedRow.FMS_Name ||
  selectedRow.Department ||
  "Unknown";

  // console.log("===== PC REMARK DEBUG =====");
  //  console.log("Selected Row:", selectedRow);
  //  console.log("Process_Name:", selectedRow.Process_Name);
  //  console.log("FMS_Name:", selectedRow.FMS_Name);
  //  console.log("Department:", selectedRow.Department);
  //  console.log("FINAL DEPARTMENT:", deptFinal);
   const payload = {
     weekStart: startDate,
     weekEnd: endDate,
     doerEmail: String(selectedRow.User_Emails || "")
       .split(",")[0]
       .trim()
       .toLowerCase(),
     doerName: selectedRow.User_Name,
     department: deptFinal,
     processName: deptFinal,
     totalScore: Number(selectedRow.Total_Average_Score || 0),
     pcRemark: pcRemarkText || "",
     createdBy: activeDoerEmail || "system@geplcapital.com",  // ✅ FIX
   };
   
  //  console.log("PC REMARK PAYLOAD:", payload); // ✅ ADD THIS
   
       const res = await fetch(`${API_BASE}/em/saveRemark`, {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify(payload),
       });
   
       const json = await res.json();
   
       if (!res.ok || !json.ok) {
         throw new Error(json?.error || "Failed to save remark");
       }
   
       setPcRemarkOpen(false);
       // ✅ update UI instantly
   setRows(prev =>
     prev.map(r =>
       r === selectedRow
         ? { ...r, PC_Remark: pcRemarkText }
         : r
     )
   );
   
    // fetchLive();

  } catch (e) {
    alert("Error: " + e.message);
  }
  finally {
    setPcRemarkSaving(false);  // ✅ ADD
  }
}


async function saveCommitment() {
  if (!selectedRow) return;

  try {
    setCommitmentSaving(true);
    const deptFinal =
  selectedRow.Process_Name ||
  selectedRow.FMS_Name ||
  selectedRow.Department ||
  "Unknown";

// console.log("===== COMMITMENT DEBUG =====");
// console.log("Selected Row:", selectedRow);
// console.log("FINAL DEPARTMENT:", deptFinal);
const payload = {
  weekStart: startDate,
  weekEnd: endDate,
  doerEmail: String(selectedRow.User_Emails || "")
    .split(",")[0]
    .trim()
    .toLowerCase(),
  doerName: selectedRow.User_Name,
  department: deptFinal,
  processName: deptFinal,
  commitmentScore: Number(commitmentScore || 0),
  commitmentRemark: commitmentText || "",
  createdBy: activeDoerEmail || "system@geplcapital.com", // ✅ FIX
};

// console.log("COMMITMENT PAYLOAD:", payload); // ✅ ADD THIS
    const res = await fetch(`${API_BASE}/em/saveCommitment`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const json = await res.json();

    if (!res.ok || !json.ok) {
      throw new Error(json?.error || "Failed to save commitment");
    }

    setCommitmentOpen(false);
    // fetchLive();
    // ✅ update UI instantly
setRows(prev =>
  prev.map(r =>
    r === selectedRow
      ? {
          ...r,
          Doer_Commitment: commitmentText,
          Doer_Commitment_Score: Number(commitmentScore || 0),
        }
      : r
  )
);

  } catch (e) {
    alert("Error: " + e.message);
  }finally {
    setCommitmentSaving(false);  // ✅ ADD
  }
}



async function handleWeeklyBulkSave() {
  try {
    setBulkLoading(true);
    setBulkMsg("");

    const payload = rows.map(r => {
      const deptFinal =
        r.Process_Name ||
        r.FMS_Name ||
        r.Department ||
        "Unknown";

return {
  weekStart: startDate,
  weekEnd: endDate,

  doerEmail: String(r.User_Emails || "")
    .split(",")[0]
    .trim()
    .toLowerCase(),

  doerName: r.User_Name,

  department: deptFinal,
  processName: deptFinal,

  // ✅ EXISTING
  totalScore: Number(r.Total_Average_Score || 0),

  // ✅ NEW FIELDS
  totalTask: Number(r.Total_Planned ?? r.Total_Task ?? 0),
  taskDone: Number(r.Task_Done ?? 0),
  taskNotDone: Number(r.Task_Not_Done ?? 0),
  doneOnTime: Number(r.TaskDoneOnTime ?? 0),
  doneDelay: Number(r.TaskDoneNotOnTime ?? 0),

  penaltyScore: Number(r.Penalty_Score || 0),
  finalScore: Number(r.Final_Score || 0),

  // ✅ DOER STATUS FROM MAP
  doerStatus:
    doerStatusMap[
      String(r.User_Emails || "")
        .split(",")[0]
        .trim()
        .toLowerCase()
   ] || "No Mapping",
    Department_Name_In_HRMantra: r.Department_Name_In_HRMantra || "",

  createdBy: activeDoerEmail || "system@geplcapital.com"
};
    });

    const res = await fetch(`${API_BASE}/em/saveWeeklyBulk`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: payload }),
    });

    const json = await res.json();

    if (!res.ok || !json.ok) {
      throw new Error(json?.error || "Failed");
    }

    setBulkMsg("✅ Week finalized successfully");

  } catch (e) {
    setBulkMsg("❌ " + e.message);
  } finally {
    setBulkLoading(false);
  }
}
// ✅ hardcoded for now
// const SUBMITTED_BY_EMAIL = "pavankumar@geplcapital.com";

// ====================== ✅ SUBMIT API CALL ======================
async function submitCorrection() {
  if (!submitCtx) return;
const validDates = getPrevious2ValidDatesIst();
const canSubmit = isWithinSubmitWindowIst();
const ctxDate = String(submitCtx.gridDate || "").slice(0, 10);

if (!canSubmit) {
  setSubmitMsg("⚠ Correction form can be submitted only between 08:00 AM and 12:00 PM IST.");
  return;
}

if (!validDates.includes(ctxDate)) {
  setSubmitMsg(`⚠ Correction form can be submitted only for previous 2 valid dates: ${validDates.join(", ")}`);
  return;
}
  const taskIds = Array.from(selectedTasks);
  if (taskIds.length === 0) {
    setSubmitMsg("⚠ Please select at least one Task ID.");
    return;
  }

  setSubmitBusy(true);
  setSubmitMsg("");

  try {
    const payload = {
      department: submitCtx.department,
      processKey: submitCtx.processKey,     // ✅ unique
      doerName: submitCtx.doerName,
      doerEmail: submitCtx.doerEmail,
      gridDate: submitCtx.gridDate,
      processName: submitCtx.displayName,  // store process/indent here
      taskIds,
      remarksType,
      remarksText,
      // submittedBy: SUBMITTED_BY_EMAIL,
      submittedBy: activeDoerEmail,
    };
    // console.log("[SUBMIT] payload.processKey =", payload.processKey, "department =", payload.department, "processName =", payload.processName, "gridDate =", payload.gridDate, "taskIds =", taskIds);

    const res = await fetch(`${API_BASE}/scoring/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const json = await res.json();
    if (!res.ok || !json.ok) throw new Error(json?.error || "Submit failed");

    setSubmitMsg("✅ Submitted successfully");
    setTimeout(() => closeSubmitPopup(), 700);
  } catch (e) {
    setSubmitMsg(`⚠ ${e.message || String(e)}`);
  } finally {
    setSubmitBusy(false);
  }
}

function matchScoreFilter(r) {
  const total = Number(r.Total_Average_Score || 0);
  const final = Number(r.Final_Score || 0);

  if (!scoreFilter) return true;

  if (scoreFilter === "above") {
    return (
      (total <= -20 && total >= -100) ||
      (final <= -20 && final >= -100)
    );
  }

  if (scoreFilter === "below") {
    return (
      (total > -20 && total <= 0) ||
      (final > -20 && final <= 0)
    );
  }

  return true;
}


// ====================== ✅ APPROVAL POPUP STATE ======================
const [approvalOpen, setApprovalOpen] = useState(false);
const [approvalSub, setApprovalSub] = useState(null);
const [approvalBusy, setApprovalBusy] = useState(false);
const [approvalMsg, setApprovalMsg] = useState("");
const [hodRejectRemark, setHodRejectRemark] = useState("");
const [hodAction, setHodAction] = useState(""); // "Accepted" | "Rejected"

// ✅ hardcoded for now (later: take from login session)
// const HOD_ACTION_BY_EMAIL = "pavankumar@geplcapital.com";
const [approvalListOpen, setApprovalListOpen] = useState(false);
const [approvalListSubs, setApprovalListSubs] = useState([]);

function openApprovalListPopup(subs) {
  setApprovalListSubs(subs || []);
  setApprovalListOpen(true);
}
function closeApprovalListPopup() {
  setApprovalListOpen(false);
  setApprovalListSubs([]);
}
function openApprovalPopup(sub) {
  if (pageMode !== "hod") return;

  setApprovalMsg("");
  setHodRejectRemark("");
  setHodAction("");
  setApprovalSub(sub);
  setApprovalOpen(true);
}

function closeApprovalPopup() {
  setApprovalOpen(false);
  setApprovalSub(null);
  setApprovalBusy(false);
  setApprovalMsg("");
  setHodRejectRemark("");
  setHodAction("");
}

function handleResetFilters() {
  setSearch("");
  setDepartment("All");
  setSelectedHrDept("");
  setScoreFilter("");


}
// ✅ call backend: /scoring/hodAction
async function submitHodAction() {
  if (!approvalSub) return;

  const deptForAction = safeStr(approvalSub.Department || department || "");
  const processKey = safeStr(approvalSub.Process_Key || "");

  if (!deptForAction || !processKey) {
    setApprovalMsg("⚠ Missing Department / Process Key");
    return;
  }

  if (!hodAction) {
    setApprovalMsg("⚠ Please select Accept/Reject");
    return;
  }

  if (hodAction === "Rejected" && !hodRejectRemark.trim()) {
    setApprovalMsg("⚠ Reject remark is required");
    return;
  }

  setApprovalBusy(true);
  setApprovalMsg("");

  try {
    const res = await fetch(`${API_BASE}/scoring/hodAction`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        department: deptForAction,
        processKey,
        action: hodAction,
        // actionBy: HOD_ACTION_BY_EMAIL,
        actionBy: activeDoerEmail,
        hodRejectRemark: hodAction === "Rejected" ? hodRejectRemark : "",
      }),
    });

    const json = await res.json();
    if (!res.ok || !json.ok) throw new Error(json?.error || "HOD action failed");

    setApprovalMsg("✅ Saved");

    // Update the OUTER "View Approvals" list in place too — it's a
    // separate snapshot from `rows`, so reloading `rows` alone doesn't
    // refresh what this popup is currently showing.
    setApprovalListSubs(prev =>
      prev.map(sub =>
        sub.Process_Key === approvalSub.Process_Key
          ? {
              ...sub,
              HOD_Approve_Rejection: hodAction,
              HOD_Reject_Remark: hodAction === "Rejected" ? hodRejectRemark : sub.HOD_Reject_Remark
            }
          : sub
      )
    );

    await fetchLive();
    setTimeout(() => closeApprovalPopup(), 700);
  } catch (e) {
    setApprovalMsg(`⚠ ${e.message || String(e)}`);
  } finally {
    setApprovalBusy(false);
  }
}


const groupedRows = useMemo(() => {
  const q = search.trim().toLowerCase();

  let base = rows;

  // ✅ Score filter
  base = base.filter(matchScoreFilter);

  // ✅ HR Department filter
if (selectedHrDept) {
  base = base.filter(r =>
    safeStr(r.Department_Name_In_HRMantra) === selectedHrDept
  );
}

  // ✅ Search filter
  if (q) {
    base = base.filter((r) => {
      const hay = [
        r.User_Name,
        r.User_Emails,
        r.Location,
        r.Department,
        r.Department_Name_In_HRMantra,
        r.Process_Name,
      ]
        .map(safeStr)
        .join(" | ")
        .toLowerCase();

      return hay.includes(q);
    });
  }

  return groupByDoer(base);
},[rows, search, selectedHrDept, scoreFilter]);

  async function fetchLive() {
    setErr("");
    setLoading(true);
    try {
      const url =
        `${API_BASE}/scoring/live` +
        `?department=${encodeURIComponent(department)}` +
        `&startDate=${encodeURIComponent(startDate)}` +
        `&endDate=${encodeURIComponent(endDate)}`;

      const res = await fetch(url);
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json?.error || "Failed to load live data");
      let baseRows = Array.isArray(json.data) ? json.data : [];

// ✅ FETCH EM REVIEW DATA
const emRes = await fetch(
  `${API_BASE}/em/review?weekStart=${startDate}&weekEnd=${endDate}`
);
const emJson = await emRes.json();

const emMap = emJson?.data || {};

// ✅ MERGE EM DATA INTO ROWS
baseRows = baseRows.map((r) => {
  const email = String(r.User_Emails || "")
  .split(",")[0]
  .trim()
  .toLowerCase();

const deptKey =
  r.Process_Name ||
  r.FMS_Name ||
  r.Department ||
  "Unknown";

const key = `${deptKey}||${email}||${startDate}_to_${endDate}`;
// console.log("===== KEY MATCH DEBUG =====");
// console.log("Row Process_Name:", r.Process_Name);
// console.log("Row FMS_Name:", r.FMS_Name);
// console.log("Row Department:", r.Department);
// console.log("Generated KEY:", key);

  const em = emMap[key];

  if (!em) return r;

  return {
    ...r,
    PC_Remark: em.pc_remark || "",
    Doer_Commitment: em.doer_commitment_remark || "",
    Doer_Commitment_Score: em.doer_commitment_score ?? null,
  };
});

setRows(baseRows);
    } catch (e) {
      setErr(e.message || String(e));
      setRows([]);
    } finally {
      setLoading(false);
    }
  }


async function fetchDoerStatus() {
  try {
    setLoading(true);

    const emails = [
      ...new Set(
        rows.map(r =>
          String(r.User_Emails || "")
            .split(",")[0]
            .trim()
            .toLowerCase()
        )
      )
    ];

    const res = await fetch(`${API_BASE}/em/doer-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ emails })
    });

    const json = await res.json();

    if (!res.ok || !json.ok) {
      throw new Error(json?.error || "Failed to fetch status");
    }

    // expected format: { email: status }
    setDoerStatusMap(json.data || {});

  } catch (e) {
    alert("Error fetching doer status: " + e.message);
  } finally {
    setLoading(false);
  }
}
 
  async function openDetails(row) {
    setActiveRow(row);
    setModalOpen(true);
    setGridData(null);
    setGridErr("");
    setGridLoading(true);

    try {
      const rowKey = row.__rowKey || row.Row_Key || row.rowKey;
      //  console.log("[OPEN DETAILS] rowKey =", rowKey, "row.Department =", row.Department, "row.Process_Name =", row.Process_Name, "row.User_Emails =", row.User_Emails);

      // ✅ If dropdown is "All", pass row's own department
      const deptForGrid = safeStr(row.Department || department || "Accounts");

const url =
  `${API_BASE}/scoring/grid` +
  `?department=${encodeURIComponent(deptForGrid)}` +
  `&startDate=${encodeURIComponent(startDate)}` +
  `&endDate=${encodeURIComponent(endDate)}` +
  `&rowKey=${encodeURIComponent(rowKey)}` +
  `&mode=errorCorrection` +          // ✅ ADD
  `&isCustomDate=true`;              // ✅ ADD

      const res = await fetch(url);
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json?.error || "Failed to load grid");
      setGridData(json.data || null);
    } catch (e) {
      setGridErr(e.message || String(e));
      setGridData(null);
    } finally {
      setGridLoading(false);
    }
  }

  function closeModal() {
    setModalOpen(false);
    setActiveRow(null);
    setGridData(null);
    setGridErr("");
    setGridLoading(false);
  }

function getScoreCellClass(value) {
  const n = Number(value);

  if (isNaN(n)) return "scoreFull";

  if (n > -20) {
    return "scoreFull scoreGreen";
  }

  if (n <= -20) {
    return "scoreFull scoreRed";
  }

  return "scoreFull";
}

  // ✅ Load meta only once
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/scoring/meta`);
        const json = await res.json();
        if (res.ok && json.ok) {
          const list = json.data?.departments || [];
          setDepts(list);
          if (list.includes("All")) setDepartment("All");
          else if (list.length) setDepartment(list[0]);
        }
      } catch (e) {
        console.warn("Meta load failed:", e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
const hrDeptOptions = useMemo(() => {
  let base = rows;

  // 🔥 Apply score filter FIRST
  if (scoreFilter) {
    base = base.filter(matchScoreFilter);
  }

  return [
    ...new Set(
      base
        .map(r => safeStr(r.Department_Name_In_HRMantra))
        .filter(v => v && v.trim() !== "")
    )
  ];
}, [rows, scoreFilter]);
  // ✅ Auto-load when Department changes
useEffect(() => {
  if (!department || !isReady) return;

  fetchLive();
}, [department, isReady]);

const COLS = pageMode === "em" ? 20 : 18;

useEffect(() => {
  const tick = () => {
    setIstClock(getIstNowParts());
    setAllowedDates(getPrevious2ValidDatesIst());
  };

  tick();
  const id = setInterval(tick, 30000); // refresh every 30 sec

  return () => clearInterval(id);
}, []);

const canSubmitNow = isWithinSubmitWindowIst();
const isSelectedDateAllowed = allowedDates.includes(startDate);
const submitUiAllowed = canSubmitNow && isSelectedDateAllowed;

  return (
    <div className="dstWrap">
      <div className="dstHeader">


        <div className="dstControls">
<div className="filterContainer">

  {/* LEFT SIDE (70%) */}
  <div className="filterLeft">

    {/* ROW 1 → Start | End | Load */}
    <div className="filterRow">
      <div className="ctrl">
        <label>Start</label>
        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
      </div>

      <div className="ctrl">
        <label>End</label>
        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      </div>

      <label
  style={{
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 6,
    fontSize: 13,
    cursor: "pointer",
    userSelect: "none"
  }}
>
  <input
    type="checkbox"
    checked={usePreviousWeek}
    onChange={(e) => {
      const checked = e.target.checked;

      setUsePreviousWeek(checked);

      if (checked) {
        const range = getPreviousWeekRange();

        setStartDate(range.start);
        setEndDate(range.end);
      } else {
        const today = fmtDateInput(new Date());

        setStartDate(today);
        setEndDate(today);
      }
    }}
  />

  Previous Week
</label>

      <button className="btnPrimary" onClick={fetchLive} disabled={loading}>
        {loading ? "Loading..." : "Load"}
      </button>

      <button
        className="btnGhost"
        onClick={handleResetFilters}
        style={{ minWidth: 100 }}
      >
        Reset
      </button>
    </div>

    {/* ROW 2 → Score | HR | Process */}
    <div className="filterRow">

      <div className="ctrl">
        <label>Score Filter</label>
        <select value={scoreFilter} onChange={(e) => setScoreFilter(e.target.value)}>
          <option value="">All</option>
          <option value="above">Above -20 (-20 to -100)</option>
          <option value="below">Below -20 (0 to -19)</option>
        </select>
      </div>

      <div className="ctrl">
        <label>HR Department</label>
        <select value={selectedHrDept} onChange={(e) => setSelectedHrDept(e.target.value)}>
          <option value="">All</option>
          {hrDeptOptions.map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
      </div>

      <div className="ctrl">
        <label>Process Name</label>
        <select value={department} onChange={(e) => setDepartment(e.target.value)}>
          {(depts.length ? depts : [department]).map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
      </div>

      <div className="ctrl">
        <label>Search</label>
        <input
          placeholder="Doer Name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

    </div>

  </div>


  {/* RIGHT SIDE (30%) */}
<div className="filterRight">

{pageMode === "em" ? (
  <>
    {isRuchiraUser && (
      <>
        <button
          className="btnPrimary"
          style={{ background: "#16a34a", minWidth: 160 }}
          onClick={handleWeeklyBulkSave}
          disabled={bulkLoading}
        >
          {bulkLoading ? "Processing..." : "Finalize Week"}
        </button>

        <button
          className="btnGhost"
          style={{ minWidth: 160 }}
          onClick={fetchDoerStatus}
        >
          Fetch Doer Status
        </button>
      </>
    )}

    {bulkLoading && (
      <div className="progressBarWrap">
        <div className="progressBar" />
      </div>
    )}

    {bulkMsg && (
      <div className={`msg ${bulkMsg.startsWith("✅") ? "success" : "error"}`}>
        {bulkMsg}
      </div>
    )}
  </>
)
  
  : (
    <div
      style={{
        padding: "10px 12px",
        borderRadius: 10,
        background: submitUiAllowed ? "#ecfdf5" : "#fff7ed",
        border: `1px solid ${submitUiAllowed ? "#a7f3d0" : "#fdba74"}`,
        color: "#334155",
        fontSize: 10.5,
        lineHeight: 1.5,
      }}
    >
      <div><b>Current Time:</b> {istClock.timeStr}</div>
      <div><b>Correction Time:</b> 08:00 AM to 12:00 PM</div>
      <div><b>Allowed Dates:</b> {allowedDates.join(", ")}</div>
      <div>
        <b>Status:</b>{" "}
        {canSubmitNow
          ? isSelectedDateAllowed
            ? "Submission allowed"
            : "Selected date is not allowed"
          : "Submission window is closed"}
      </div>
    </div>
  )}

</div>



</div>

        </div>

        
      </div>


      <div className="tableCard">
       

        <div className="tableScroll">
          <table className="dstTable">


 
<thead>
  <tr>
    <th className="col-date">Date</th>
    <th className="col-name">Doer Name</th>

    {pageMode === "em" && <th className="col-status">Doer Status</th>}

    <th className="col-mobile">Mobile</th>
    <th className="col-location">Location</th>
    <th className="col-hrdept">Department</th>
    <th className="col-dept">Process</th>

    <th className="col-num">Total</th>
    <th className="col-num">Done</th>
    <th className="col-num">Not Done</th>
    <th className="col-num">On Time</th>
    <th className="col-num">Delay</th>

    <th className="col-cumulative">Cumulative</th>
    <th className="col-score">Total Score</th>
<th className="col-final">Final Score</th>

{pageMode === "em" && (
  <th className="col-remark">PC Remark</th>
)}

<th className="col-icon">Details</th>
<th className="col-icon">Previous</th>

<th className="col-approval">Score Adjustment Remarks</th>

{pageMode === "em" && (
  <th className="col-commitment">Commitment</th>
)}
  </tr>
</thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={COLS} className="centerCell">
                    Loading...
                  </td>
                </tr>
              ) : groupedRows.length === 0 ? (
                <tr>
                  <td colSpan={COLS} className="centerCell">
                    No data
                  </td>
                </tr>
              ) : (
                groupedRows.map((g, gIdx) => {
                  const list = g.list;

                  // ✅ TOTAL should be only if doer appears in 2+ Departments (not based on number of rows)
                  const deptCount = new Set(list.map((r) => safeStr(r.Department))).size;
                  const hasTotal = deptCount > 1;

                  // totals across departments
                  const totals = list.reduce(
                    (acc, r) => {
                      acc.total += Number(r.Total_Planned ?? r.Total_Task ?? 0);
                      acc.done += Number(r.Task_Done ?? 0);
                      acc.notDone += Number(r.Task_Not_Done ?? 0);
                      acc.onTime += Number(r.TaskDoneOnTime ?? 0);
                      acc.delay += Number(r.TaskDoneNotOnTime ?? 0);
                      return acc;
                    },
                    { total: 0, done: 0, notDone: 0, onTime: 0, delay: 0 }
                  );

                  const score = calcScoreFromCounts(
                    totals.total,
                    totals.done,
                    totals.notDone,
                    totals.delay
                  );

                  return (
                    <React.Fragment key={g.key + "|" + gIdx}>
                      {list.map((r, idx) => {
                        const dateRange = safeStr(r.Date_Range || r.date_range || r.dateRange || "");

                        const doer = safeStr(r.User_Name || r.Doer_Name || "");
                        const email = safeStr(r.User_Emails || r.Doer_Email || "");

                        const mobile = safeStr(r.MobileNumber || r.Mobile_Number || "");
                        const loc = safeStr(r.Location || "");
                        const hrDept = safeStr(r.Department_Name_In_HRMantra || "");
                        const dept = safeStr(r.Department || "");
                        const total = r.Total_Planned ?? r.Total_Task ?? "";
                        const done = r.Task_Done ?? "";
                        const notDone = r.Task_Not_Done ?? r.Task_NotDone ?? "";
                        const onTime = r.TaskDoneOnTime ?? r.Task_Done_OnTime ?? "";
                        const delay = r.TaskDoneNotOnTime ?? r.Task_Done_Delay ?? "";

                        const cumulativeScore =
                         r.Cumulative_Total_Average_Score ??
                       
                         "";
                        const totalScore = r.Total_Average_Score ?? r.Total_Score ?? r.TotalScore ?? "";
                        const showEmAction = Number(totalScore) <= -20;

                        const hod = r.Latest_Submission?.HOD_Approve_Rejection || "";

                        // ✅ rowSpan should include TOTAL row only if hasTotal=true
                        const rowSpan = idx === 0 ? list.length + (hasTotal ? 1 : 0) : 0;
const hasFinal = r.Final_Score !== "" && r.Final_Score !== "-" && r.Final_Score != null;
                        return (


<tr key={safeStr(r.__rowKey) + "|" + idx}>

{/* DATE */}
{idx === 0 && (
  <td rowSpan={rowSpan} className={`col-date ${hasTotal ? "vCenter" : ""}`}>
    {dateRange?.includes(" to ")
      ? (
        <>
          <div>{dateRange.split(" to ")[0]}</div>
          <div className="date-sep">to</div>
          <div>{dateRange.split(" to ")[1]}</div>
        </>
      )
      : dateRange}
  </td>
)}

{/* DOER NAME */}
{idx === 0 && (
  <td rowSpan={rowSpan} className={`col-name ${hasTotal ? "vCenter" : ""}`}>
    {doer}
  </td>
)}

{/* DOER STATUS */}
{pageMode === "em" && idx === 0 && (
  <td rowSpan={rowSpan} className={`col-status ${hasTotal ? "vCenter" : ""}`}>
    {doerStatusMap[email] || <span className="mutedSmall">—</span>}
  </td>
)}

{/* MOBILE */}
{idx === 0 && (
  <td rowSpan={rowSpan} className={`col-mobile ${hasTotal ? "vCenter" : ""}`}>
    {mobile}
  </td>
)}

{/* LOCATION */}
{idx === 0 && (
  <td rowSpan={rowSpan} className={`col-location ${hasTotal ? "vCenter" : ""}`}>
    {loc}
  </td>
)}

{/* HR DEPT */}
{idx === 0 && (
  <td rowSpan={rowSpan} className={`col-hrdept ${hasTotal ? "vCenter" : ""}`}>
    {hrDept || <span className="mutedSmall">—</span>}
  </td>
)}

{/* DEPARTMENT */}
<td className="col-dept">{dept}</td>


{/* NUMBERS */}
<td className="col-num">{safeStr(total)}</td>
<td className="col-num">{safeStr(done)}</td>

<td className={`col-num ${Number(notDone) > 0 ? "text-red" : ""}`}>
  {safeStr(notDone)}
</td>

<td className="col-num">{safeStr(onTime)}</td>

<td className={`col-num ${Number(delay) > 0 ? "text-red" : ""}`}>
  {safeStr(delay)}
</td>

{/* CUMULATIVE */}
<td className="col-cumulative">
  {cumulativeScore !== "" ? (
    <div className="cumulativeWrapper">
      <div className="cumulativeScore">
        {Number(cumulativeScore).toFixed(2)}
      </div>
      {r.Cumulative_Date_Range && (
        <div className="cumulativeDate">
          {r.Cumulative_Date_Range}
        </div>
      )}
    </div>
  ) : (
    <span className="mutedSmall">—</span>
  )}
</td>

{/* TOTAL SCORE */}
<td className={`col-score ${getScoreCellClass(r.Total_Average_Score)}`}>
  {r.Total_Average_Score !== ""
    ? Number(r.Total_Average_Score).toFixed(2)
    : "—"}
</td>

{/* FINAL SCORE */}
<td
  className={`col-final ${hasFinal ? getScoreCellClass(r.Final_Score) : ""}`}
  onClick={() => {
    if (Number(r.Penalty_Score || 0) !== 0 && r.Penalty_Reason) {
      setPenaltyReason(r.Penalty_Reason);
      setPenaltyPopupOpen(true);
    }
  }}
>
  {Number(r.Penalty_Score || 0) !== 0 ? (
    <div className="finalScoreBox">
      <div className="finalScoreValue">
        {Number(r.Final_Score).toFixed(2)}
      </div>
      <div className="penaltyText">
        Penalty: {Number(r.Penalty_Score).toFixed(2)}
      </div>
    </div>
  ) : "—"}
</td>


{/* PC REMARK */}
{pageMode === "em" && (
  <td className="col-remark">
    {renderPcRemarkCell(r, openPcRemarkPopup)}
  </td>
)}
{/* DETAILS */}
<td className="col-icon">
  <button className="iconBtn" onClick={() => openDetails(r)}>
  <LuEye size={90} />
</button>
</td>

{/* PREV */}
{idx === 0 && (
  <td rowSpan={rowSpan} className="col-icon">
    <button
      className="iconBtn"
      onClick={() => {
        const email = String(r.User_Emails || "")
          .split(",")[0]
          .trim()
          .toLowerCase();

        setProgressEmail(email);
        setProgressOpen(true);
      }}
    >
      <LuEye size={90} />
    </button>

  </td>
)}

{/* APPROVAL */}
<td className="col-approval">
  {(() => {
    const subs = getSubmissionsFromRow(r);
    const total = subs.length;
    const pending = subs.filter(s => !s?.HOD_Approve_Rejection).length;

    if (total === 0) return <span className="pill pillGray"></span>;

    return (
      <div className="approvalBox">
        <button className="btnGhost" onClick={() => openApprovalListPopup(subs)}>
          View Approvals
        </button>
        <div className="mutedSmall">
          Total: <b>{total}</b> | Pending: <b>{pending}</b>
        </div>
      </div>
    );
  })()}
</td>

{/* COMMITMENT */}
{pageMode === "em" && (
  <td className="col-commitment">
    {renderDoerCommitmentCell(r, openCommitmentPopup)}
  </td>
)}



</tr>

                        );
                      })}

                      {/* ✅ TOTAL row ONLY when doer is in multiple departments */}
                      {hasTotal ? (
<tr className="totalRow">

 {/* Date */}
  {/* <td></td> */}


  {/* Department column → show TOTAL here */}
  <td style={{ fontWeight: 900, textAlign: "left" }}>
    TOTAL
  </td>

  {/* Numbers */}
  <td>{totals.total}</td>
  <td>{totals.done}</td>
  <td>{totals.notDone}</td>
  <td>{totals.onTime}</td>
  <td>{totals.delay}</td>

  {/* Cumulative */}
  <td>—</td>

  {/* Total Score */}
  <td className={getScoreCellClass(score.Total_Average_Score)}>
    {score.Total_Average_Score}
  </td>

  {/* Details + HOD */}
  <td colSpan={3}></td>

</tr>
                      ) : null}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

{pcRemarkOpen && (
  <div className="modalBackdrop">
    <div className="modalCard modernModal">
     
      <div className="modalHeader">
        <div className="modalTitle">📝 Add PC Remark</div>
        <button className="btnClose" onClick={() => setPcRemarkOpen(false)}>✕</button>
      </div>

      <div className="modalBody">
        <textarea
          className="inputModern"
          placeholder="Write your remark..."
          value={pcRemarkText}
          onChange={(e) => setPcRemarkText(e.target.value)}
        />

        <div className="modalActions">
          <button className="btnGhost" onClick={() => setPcRemarkOpen(false)}>
            Cancel
          </button>

<button
  className="btnPrimary"
  onClick={savePcRemark}
  disabled={pcRemarkSaving}
>
  {pcRemarkSaving ? "Submitting..." : "Save Remark"}
</button>
        </div>
      </div>

    </div>
  </div>
)}

{commitmentOpen && (
  <div className="modalBackdrop">
    <div className="modalCard modernModal">

      <div className="modalHeader">
        <div className="modalTitle">🎯 Doer Commitment</div>
        <button className="btnClose" onClick={() => setCommitmentOpen(false)}>✕</button>
      </div>

      <div className="modalBody">

        <input
          className="inputModern"
          placeholder="Score (-20 to -100)"
          value={commitmentScore}
          onChange={(e) => setCommitmentScore(e.target.value)}
        />

        <textarea
          className="inputModern"
          placeholder="Write commitment..."
          value={commitmentText}
          onChange={(e) => setCommitmentText(e.target.value)}
        />

        <div className="modalActions">
          <button className="btnGhost" onClick={() => setCommitmentOpen(false)}>
            Cancel
          </button>

<button
  className="btnPrimary"
  onClick={saveCommitment}
  disabled={commitmentSaving}
>
  {commitmentSaving ? "Submitting..." : "Save Commitment"}
</button>
        </div>

      </div>
    </div>
  </div>
)}

      {/* =================== MODAL =================== */}
      {modalOpen ? (
        <div className="modalBackdrop" onMouseDown={closeModal}>
          <div className="modalCard" onMouseDown={(e) => e.stopPropagation()}>
            <div className="modalHeader">
              <div>
                <div className="modalTitle">Grid Details</div>
                <div className="mutedSmall">
                  {safeStr(activeRow?.User_Name)} • {safeStr(activeRow?.Process_Name)} •{" "}
                  {safeStr(activeRow?.Department || department)}
                </div>
              </div>
              <button className="btnClose" onClick={closeModal}>
                ✕
              </button>
            </div>

            <div className="modalBody">
              {gridLoading ? <div className="centerCell">Loading grid...</div> : null}
              {gridErr ? <div className="alertErr">⚠️ {gridErr}</div> : null}

              {!gridLoading && !gridErr && gridData ? (
<GridRenderer
  department={safeStr(activeRow?.Department || department)}
  grid={gridData}
  activeRow={activeRow}
  onOpenSubmit={openSubmitPopup}
  gridDateISO={startDate}
  canSubmitNow={canSubmitNow}
  allowedDates={allowedDates}
   mode={pageMode}
   openUidPopup={openUidPopup}
/>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}


{submitOpen && submitCtx ? (
  <div className="modalBackdrop" onMouseDown={closeSubmitPopup}>
    <div
      className="modalCard"
      style={{ width: "min(760px, 96vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div>
          <div className="modalTitle">Submit Correction</div>
          <div className="mutedSmall">
            {submitCtx.department} • {submitCtx.displayName}
          </div>
        </div>
        <button className="btnClose" onClick={closeSubmitPopup}>✕</button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 12 }}>
        <div className="mutedSmall">
          <b>Doer:</b> {submitCtx.doerName}<br/>
          <b>Email:</b> {submitCtx.doerEmail}<br/>
          <b>Date:</b> {submitCtx.gridDate}
        </div>

        <div
  style={{
    padding: "10px 12px",
    borderRadius: 10,
    background: canSubmitNow && allowedDates.includes(String(submitCtx?.gridDate || "").slice(0, 10))
      ? "#ecfdf5"
      : "#fff7ed",
    border: `1px solid ${
      canSubmitNow && allowedDates.includes(String(submitCtx?.gridDate || "").slice(0, 10))
        ? "#a7f3d0"
        : "#fdba74"
    }`,
    fontSize: 13,
    color: "#334155",
  }}
>
  <div><b>Submit Window:</b> 08:00 AM to 12:00 PM IST</div>
  <div><b>Allowed Dates:</b> {allowedDates.join(", ")}</div>
  {!canSubmitNow ? (
    <div><b>Status:</b> Submission window is closed</div>
  ) : !allowedDates.includes(String(submitCtx?.gridDate || "").slice(0, 10)) ? (
    <div><b>Status:</b> This date is not allowed for correction</div>
  ) : (
    <div><b>Status:</b> Submission allowed</div>
  )}
</div>

        <div>
          <div style={{ fontWeight: 900, marginBottom: 6 }}>
            Task IDs (Pending / Delayed)
          </div>

          <label className="mutedSmall" style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <input
              type="checkbox"
              checked={
                submitCtx.taskOptions?.length > 0 &&
                selectedTasks.size === submitCtx.taskOptions.length
              }
              onChange={(e) => {
                if (e.target.checked) setSelectedTasks(new Set(submitCtx.taskOptions || []));
                else setSelectedTasks(new Set());
              }}
            />
            Select All
          </label>

          <div style={{ maxHeight: 240, overflow: "auto", border: "1px solid #e5e7eb", borderRadius: 10, padding: 10 }}>
            {!submitCtx.taskOptions?.length ? (
              <div className="mutedSmall">No Pending/Delayed Task IDs found.</div>
            ) : (
              submitCtx.taskOptions.map((t) => (
                <label key={t} style={{ display: "flex", gap: 8, alignItems: "center", padding: "4px 0" }}>
                  <input
                    type="checkbox"
                    checked={selectedTasks.has(t)}
                    onChange={(e) => {
                      setSelectedTasks((prev) => {
                        const next = new Set(prev);
                        if (e.target.checked) next.add(t);
                        else next.delete(t);
                        return next;
                      });
                    }}
                  />
                  <span>{t}</span>
                </label>
              ))
            )}
          </div>
        </div>

        <div style={{ display: "grid", gap: 8 }}>
          <div>
            <div style={{ fontWeight: 900, marginBottom: 6 }}>Remarks Type</div>
            <select
              value={remarksType}
              onChange={(e) => setRemarksType(e.target.value)}
              style={{ width: "100%", height: 36, borderRadius: 10, border: "1px solid #d1d5db", padding: "0 10px" }}
            >
              <option>HR Mantra issue</option>
              <option>System Issue</option>
              <option>Other</option>
            </select>
          </div>

          <div>
            <div style={{ fontWeight: 900, marginBottom: 6 }}>Remarks Text</div>
            <textarea
              value={remarksText}
              onChange={(e) => setRemarksText(e.target.value)}
              rows={3}
              style={{ width: "100%", borderRadius: 10, border: "1px solid #d1d5db", padding: 10 }}
              placeholder="Write remark..."
            />
          </div>
        </div>

        {submitMsg ? (
          <div className={submitMsg.startsWith("✅") ? "muted" : "alertErr"}>
            {submitMsg}
          </div>
        ) : null}

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button className="btnGhost" onClick={closeSubmitPopup} disabled={submitBusy}>
            Cancel
          </button>
<button
  className="btnPrimary"
  onClick={submitCorrection}
  disabled={
    submitBusy ||
    !canSubmitNow ||
    !allowedDates.includes(String(submitCtx?.gridDate || "").slice(0, 10))
  }
>
  {submitBusy ? "Submitting..." : "Submit"}
</button>
        </div>
      </div>
    </div>
  </div>
) : null}

{uidPopupOpen && (
  <div className="modalBackdrop" onMouseDown={() => setUidPopupOpen(false)}>
    <div
      className="modalCard"
      style={{ width: "min(400px, 90vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div className="modalTitle">Unique IDs</div>
        <button className="btnClose" onClick={() => setUidPopupOpen(false)}>
          ✕
        </button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 6 }}>
        {uidList.map((uid, i) => (
          <div
            key={i}
            style={{
              padding: "6px 10px",
              borderRadius: 8,
              background: "#f1f5f9",
              fontSize: 13
            }}
          >
            {uid}
          </div>
        ))}

        {uidList.length === 0 && (
          <div className="mutedSmall">No IDs</div>
        )}
      </div>
    </div>
  </div>
)}


{penaltyPopupOpen && (
  <div className="modalBackdrop" onMouseDown={() => setPenaltyPopupOpen(false)}>
    <div
      className="modalCard modernModal"
      style={{ width: "min(400px, 90vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div className="modalTitle">⚠️ Penalty Reason</div>
        <button className="btnClose" onClick={() => setPenaltyPopupOpen(false)}>
          ✕
        </button>
      </div>

      <div className="modalBody">
        <div
          style={{
            padding: "10px",
            borderRadius: 10,
            background: "#fff7ed",
            border: "1px solid #fdba74",
            fontSize: 14,
            color: "#7c2d12"
          }}
        >
          {/* {penaltyReason || "No reason available"} */}
          {formatPenaltyReason(penaltyReason)}
        </div>

        <div className="modalActions">
          <button
            className="btnPrimary"
            onClick={() => setPenaltyPopupOpen(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{approvalListOpen ? (
  <div className="modalBackdrop" onMouseDown={closeApprovalListPopup}>
    <div
      className="modalCard"
      style={{ width: "min(860px, 96vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div>
          <div className="modalTitle">HOD Approvals (All Forms)</div>
<div className="mutedSmall">
  {safeStr(approvalListSubs?.[0]?.Doer_Name || approvalListSubs?.[0]?.User_Name || "—")} •{" "}
  {safeStr(approvalListSubs?.[0]?.Doer_Email || approvalListSubs?.[0]?.User_Emails || "—")}
</div>
        </div>
        <button className="btnClose" onClick={closeApprovalListPopup}>✕</button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 10 }}>
        {approvalListSubs.map((sub, i) => {
  const status = sub?.HOD_Approve_Rejection || "Pending";

  return (
    <div key={safeStr(sub?.Process_Key) + "|" + i} className="processCard" style={{ background: "#fff" }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
        <div style={{ fontWeight: 900 }}>
          {safeStr(sub?.Process_Name || "—")}
        </div>

        <span className={
          status === "Accepted" ? "pill pillGreen"
          : status === "Rejected" ? "pill pillRed"
          : "pill pillOrange"
        }>
          {status}
        </span>
      </div>

      <div className="mutedSmall" style={{ display: "grid", gap: 4, marginTop: 6 }}>
        <div><b>Grid Date:</b> {safeStr(sub?.Grid_Date || "—")}</div>
        <div><b>Remarks Type:</b> {safeStr(sub?.Remarks_Type || "—")}</div>
        <div><b>Remarks:</b> {safeStr(sub?.Remarks_Text || "—")}</div>
        {status === "Rejected" ? (
          <div><b>Reject Remark:</b> {safeStr(sub?.HOD_Reject_Remark || "—")}</div>
        ) : null}
      </div>

     {pageMode === "hod" && !sub?.HOD_Approve_Rejection ? (
  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
    <button className="btnPrimary" onClick={() => openApprovalPopup(sub)}>
      Take Action
    </button>
  </div>
) : null}
    </div>
  );
})}

{approvalListSubs.length === 0 ? (
  <div className="mutedSmall">No submissions found for this doer.</div>
) : null}
      </div>
    </div>
  </div>
) : null}
{approvalOpen && approvalSub ? (
  <div className="modalBackdrop modalBackdropTop" onMouseDown={closeApprovalPopup}>
    <div
      className="modalCard"
      style={{ width: "min(620px, 96vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div>
          <div className="modalTitle">HOD Approval</div>
          <div className="mutedSmall">
  {safeStr(approvalSub?.Doer_Name || approvalSub?.User_Name || "—")} •{" "}
  {safeStr(approvalSub?.Department || "—")} •{" "}
  {safeStr(approvalSub?.Process_Name || "—")}
</div>
        </div>
        <button className="btnClose" onClick={closeApprovalPopup}>✕</button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 12 }}>
        {/* ✅ DETAILS FROM SUBMISSION */}
        <div className="processCard" style={{ background: "#fff" }}>
          <div className="mutedSmall" style={{ display: "grid", gap: 6 }}>
           <div><b>Process Name:</b> {safeStr(approvalSub?.Process_Name || "—")}</div>
<div><b>Grid Date:</b> {safeStr(approvalSub?.Grid_Date || "—")}</div>
<div><b>Remarks Type:</b> {safeStr(approvalSub?.Remarks_Type || "—")}</div>
<div><b>Remarks Text:</b> {safeStr(approvalSub?.Remarks_Text || "—")}</div>

          </div>
        </div>

        {/* ✅ STATUS */}
        <div className="mutedSmall">
          <b>Status:</b> {approvalSub?.HOD_Approve_Rejection ? approvalSub.HOD_Approve_Rejection : "Pending"}
        </div>

        {/* ✅ IF ALREADY DONE → READ ONLY */}
{approvalSub?.HOD_Approve_Rejection ? (
  <>
    {approvalSub.HOD_Approve_Rejection === "Rejected" ? (
      <div className="processCard" style={{ background: "#fff" }}>
        <div style={{ fontWeight: 900, marginBottom: 6 }}>Reject Remark</div>
        <div className="mutedSmall">
          {safeStr(approvalSub?.HOD_Reject_Remark || "—")}
        </div>
      </div>
    ) : null}

    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <button className="btnGhost" onClick={closeApprovalPopup}>
        Close
      </button>
    </div>
  </>
) : (
          <>
            {/* ✅ ACTION DROPDOWN */}
            <div style={{ display: "grid", gap: 6 }}>
              <div style={{ fontWeight: 900 }}>Action</div>
              <select
                value={hodAction}
                onChange={(e) => setHodAction(e.target.value)}
                style={{
                  width: "100%",
                  height: 36,
                  borderRadius: 10,
                  border: "1px solid #d1d5db",
                  padding: "0 10px",
                  background: "#fff",
                }}
              >
                <option value="">Select Action</option>
                <option value="Accepted">Accept</option>
                <option value="Rejected">Reject</option>
              </select>
            </div>

            {/* ✅ REJECT REMARK ONLY WHEN REJECT */}
            {hodAction === "Rejected" ? (
              <div style={{ display: "grid", gap: 6 }}>
                <div style={{ fontWeight: 900 }}>Reject Remark (required)</div>
                <textarea
                  value={hodRejectRemark}
                  onChange={(e) => setHodRejectRemark(e.target.value)}
                  rows={3}
                  style={{ width: "100%", borderRadius: 10, border: "1px solid #d1d5db", padding: 10 }}
                  placeholder="Write reject remark..."
                />
              </div>
            ) : null}

            {approvalMsg ? (
              <div className={approvalMsg.startsWith("✅") ? "muted" : "alertErr"}>
                {approvalMsg}
              </div>
            ) : null}

            {/* ✅ BUTTONS */}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button className="btnGhost" onClick={closeApprovalPopup} disabled={approvalBusy}>
                Cancel
              </button>

              <button
                className="btnPrimary"
                onClick={submitHodAction}
                disabled={approvalBusy}
              >
                {approvalBusy ? "Saving..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
) : null}

      {/* Local CSS */}
      <style>{`
        .dstWrap{ padding:2px 14px; }
.dstHeader{
  display:flex;
  flex-direction: column;   /* 🔥 IMPORTANT */
  width:100%;
  margin-bottom:12px;
}
        .dstTitle{ font-size:18px; font-weight:700; }
        .dstSub{ font-size:12px; color:#6b7280; margin-top:2px;}
.dstControls {
  width:100%;              /* 🔥 IMPORTANT */
  display:block;           /* simpler */
}
        .ctrl{ display:flex; flex-direction:column; gap:2px;}
        .ctrl label{ font-size:11px; color:#6b7280;}
        .ctrl input, .ctrl select{
          padding:5px 3px; border:1px solid #d1d5db; border-radius:8px; outline:none; min-width:160px;font-size: 11px;background:#fff;
        }
        .btnPrimary{
          padding:5px 14px; border:none; border-radius:5px; cursor:pointer;
          background:#1f4e8c; color:#fff; font-weight:600;
        }
        .btnPrimary:disabled{ opacity:.6; cursor:not-allowed; }
        .alertErr{
          background:#fee2e2; border:1px solid #fecaca; color:#991b1b; padding:10px 12px; border-radius:10px; margin:10px 0;
        }

        .tableCard{ background:#fff; border:1px solid #e5e7eb; border-radius:5px; overflow:hidden; }
        .tableMeta{ display:flex; justify-content:space-between; padding:10px 12px; border-bottom:1px solid #e5e7eb; font-size:13px; }
        .muted{ color:#6b7280; }
        .mutedSmall{ color:#6b7280; font-size:11px; }
.tableScroll {
  overflow-y: auto;
  overflow-x: auto;
  max-height: 70vh;
  position: relative;   /* needed for sticky */
}
.iconBtn {
  width: 33px;
  height: 28px;
  border: none;

  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  transition: all 0.2s ease;
}

.iconBtn:hover {
  color: #1f4e8c;
  transform: scale(1.15);
}
/* Header fix */
.dstTable thead th {
  position: sticky;
  top: 0;
  z-index: 6;
}
.filterContainer {
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;   /* 🔥 spreads left & right */
}

/* LEFT SIDE */
.filterLeft {
  flex: 7.5;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* RIGHT SIDE */
.filterRight {
  flex: 2.5;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ROW */
.filterRow {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: end;
}

/* FULL WIDTH SEARCH */
.fullWidth {
  width: 100%;
}

.fullWidth input {
  width: 100%;
}

/* Progress */
.progressBarWrap {
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progressBar {
  height: 100%;
  width: 100%;
  background: #16a34a;
  animation: progressAnim 1s linear infinite;
}

/* Message */
.msg {
  font-size: 12px;
}

.msg.success {
  color: #16a34a;
}

.msg.error {
  color: #dc2626;
}
        .modalBackdrop { z-index: 9999; }
.modalBackdropTop { z-index: 10050; }
.cumulativeWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}


/* Default */
.pcRemarkCell,
.doerCommitmentCell,
.cumulativeWrapper {
  white-space: normal;
}
.cumulativeScore {
  background-color: #afd2f0;   /* Blue */
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 11px;
  min-width: 60px;
  text-align: center;
}

.doerCommitmentCell {
  max-width: 140px;
  white-space: normal;
  word-break: break-word;
}

.cumulativeDate {
  font-size: 10px;
  color: #575f6b;
  text-align: center;
}
        .vCenter{
  vertical-align: middle !important;
}
.dstTable{
 width: 100%;
  border-collapse: collapse;
  font-size:13px;
}

/* Header */
.dstTable thead th{
  position:sticky;
  top:0;
  z-index:6;
  background:#1f4e8c;
  color:#fff;
  padding:5px 8px;
  text-align:left;
  border:1px solid #cbd5e1;   /* 🔥 vertical + horizontal */
  white-space:normal;
  word-break:break-word;
   text-align: center;
   font-size:11px
}

/* Body cells */
.dstTable tbody td{
  padding:5px 8px;
  border:1px solid #bec2c7;   /* 🔥 full grid lines */
  vertical-align:top;
  white-space:normal;
  font-size:11px;
  word-break:break-word;

}

/* Remove hover color (optional for clean look) */
.dstTable tbody tr:hover{
  background:#f9fafb;
}
        .centerCell{ text-align:center; padding:18px 8px; color:#6b7280; }

        .name{ line-height:1.1; }

.btnGhost{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  border-radius:8px;
  border:1px solid #cbd5e1;
  background:#f8fafc;
  cursor:pointer;
  font-weight:700;
  font-size:11px;
  transition:all .2s ease;
  padding:4px 2px
}

.btnGhost:hover{
  background:#1f4e8c;
  color:#fff;
  border-color:#1f4e8c;
}

.pcRemarkCell {
  width: 120px;
  max-width: 100px;
  font-size: 12px;
  min-width: 120px;

  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}

        .pill{ padding:4px 10px; border-radius:999px; font-weight:700; font-size:12px; display:inline-block; }
        .pillGray{ background:#f1f5f9; color:#334155; }
        .pillGreen{ background:#dcfce7; color:#166534; }
        .pillRed{ background:#fee2e2; color:#991b1b; }

        .badge{
  padding:4px 12px;
  border-radius:8px;   /* less round like screenshot */
  font-weight:800;
  font-size:12px;
  display:inline-block;
}
        .badgeGreen{ background:#dcfce7; color:#166534; border-color:#bbf7d0; }
        .badgeOrange{ background:#ffedd5; color:#9a3412; border-color:#fed7aa; }
        .badgeRed{ background:#fee2e2; color:#991b1b; border-color:#fecaca; }

        /* Modal */
.modalBackdrop{
  position:fixed; inset:0;
  background:rgba(15,23,42,.45);
  display:flex; align-items:center; justify-content:center;
  padding:16px;
  z-index: 9999;
}
  .modalBackdropTop{
  z-index: 20000;
}

/* Ensure the card also stacks above */
.modalBackdropTop .modalCard{
  position: relative;
  z-index: 20001;
}
        .modalCard{
          width:min(1600px, 96vw);
          border-radius: 16px;
box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          max-height:86vh;
          background:#fff; border-radius:16px; overflow:hidden; box-shadow:0 12px 40px rgba(0,0,0,.2);
          display:flex; flex-direction:column;
        }
        .modalHeader{
          display:flex; justify-content:space-between; align-items:center;
          padding:12px 14px; border-bottom:1px solid #e5e7eb; background:#0b2e5a; color:#fff;
        }
        .modalTitle{ font-weight:900; font-size:16px; }
        .btnClose{
          background:rgba(255,255,255,.15); border:1px solid rgba(255,255,255,.25);
          color:#fff; width:34px; height:34px; border-radius:10px; cursor:pointer;
        }
        .modalBody{ padding:12px; overflow:auto; }

        /* Grid */
/* Grid - New UI Like Screenshot */
/* ===== FIX COLUMN WIDTHS ===== */

.col-date {
  position: sticky;
  left: 0;
  z-index: 5;
  background: #fff;
}

.col-name {
  position: sticky;
  left: 120px; /* EXACT same as .col-date width */
  z-index: 6;
  background: #fff;
}

/* Header fix */
.dstTable thead .col-date,
.dstTable thead .col-name {
  z-index: 7;
}
.col-date {
  width: 120px;
  min-width: 121px;
  max-width: 121px;
}

.col-name {
  border-right: 2px solid #1d2d40;
}

.col-date {
  border-right: 1px solid #bec2c7;
}
.col-name {
  width: 170px;
  min-width: 170px;
  max-width: 170px;
}
.col-status { min-width: 100px; }
.col-mobile { min-width: 100px; }
.col-location { min-width: 100px; }
.col-hrdept { min-width: 120px; }
.col-dept { min-width: 90px; text-align: left;}

.col-num { min-width: 65px; text-align: center; }
.col-cumulative { min-width: 160px; text-align: center; }
.col-score { min-width: 80px; text-align: center; }
.col-final { min-width: 90px; text-align: center; }

.col-icon {
  width: 60px;
  min-width: 70px;
  max-width: 70px;
  text-align: center;
}
.col-approval { min-width: 140px; }
.col-remark { min-width: 200px; }
.col-commitment { min-width: 140px; }

.text-red { color: #cc2a2a;  font-weight:900}
.col-icon td,
.col-icon th {
  padding: 4px !important;
}
.date-sep {
  font-weight: 600;
  color: #64748b;
}

.finalScoreBox {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.finalScoreValue {
  font-weight: 600;
}

.penaltyText {
  font-size: 10px;
  color: #fff;
}

.approvalBox {
  display: grid;
  gap: 6px;
}

.processCard{
  background:#f3f4f6;
  border-radius:12px;
  padding:12px;
  border:1px solid #d1d5db;
}

.processTitle{
  font-weight:800;
  font-size:13px;
  margin-bottom:8px;
  display:flex;
  justify-content:space-between;
}

.processSteps{
  font-weight:600;
  color:#6b7280;
}

.gridTable{
  width:100%;
  border-collapse:collapse;
  font-size:12px;
  table-layout:fixed;   /* 🔥 important */
}

.gridTable th{
  background:#2f4a8a;
  color:#fff;
  font-weight:700;
  font-size:11px;
}
.gridTable th,
.gridTable td{
  width:60px;
min-width:60px;         /* 🔥 fixed width for all step columns */

  padding:6px 4px;
  text-align:center;
  border:1px solid #d1d5db;
  overflow:hidden;
}
.gridTable td:first-child,
.gridTable th:first-child {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
}

.processGridWrap{
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  gap:16px;
}

.processCard{
  background:#f3f4f6;
  border-radius:12px;
  padding:12px;
  border:1px solid #d1d5db;
}

/* If step count is more than 12, take full row */
.processCard.fullWidth{
  grid-column: span 2;
}

/* 🔴 DELAY → RED TEXT ONLY */
.cellDelay {
  color: #dc2626;        /* strong red */
  font-weight: 800;
  background: transparent;
}

/* 🟡 PLANNED → YELLOW BG + RED TEXT */
.cellPlanned {
  background: #fef3c7;   /* light yellow */
  color: black;        /* red text */
  font-weight: 800;
}

/* ✅ DONE → GREEN (optional) */
.cellDone {
  background: #dcfce7;
  color: #166534;
  font-weight: 800;
}

/* ❌ NOT DONE → RED BG */
.cellND {
  background: #fee2e2;
  color: #991b1b;
  font-weight: 800;
}

/* ⚪ NA */
.cellNA {
  background: #f1f5f9;
  color: #64748b;
}

.totalRow td{
  font-weight:800;
  vertical-align:middle;
  text-align: center;
}

/* Start yellow ONLY from Department column */
.totalRow td:nth-child(n+1){
  background:#f5d432;
  border:1px solid #e7c54b;
}

/* Make TOTAL text left aligned */
.totalRow td:nth-child(5){
  text-align:center;
  padding-left:12px;
}

.scoreFull{
  text-align:center;
  font-weight:700;
}

.scoreGreen{
  background:#31c158;
  color:#000000;
}

.scoreRed{
  background:#fe4d4d;
  color:#000000;
}

  .dateCol{
  width:110px !important;
  min-width:110px !important;
  max-width:110px !important;
  text-align:left !important;
  font-weight:700;
  background:#ffffff;
  position:sticky;
  left:0;
  z-index:1;
}
.gridTable th.dateCol{
  background:#2f4a8a !important;
  color:#fff !important;
  z-index:2;
}
 

/* ✅ MODERN MODAL UI */

.modernModal {
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  padding: 0;
  overflow: hidden;
}

.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.modalTitle {
  font-size: 16px;
  font-weight: 700;
  color: #122c90;
}

.modalBody {
  padding: 16px;
  display: grid;
  gap: 12px;
}

.modalActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

/* ✅ Inputs */

.inputModern {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
}

.inputModern:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37,99,235,0.1);
}

/* ✅ Close Button */

.btnClose {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  color: #64748b;
}

.btnClose:hover {
  color: #ef4444;
}


@keyframes progressAnim {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
      `}</style>
   

     {/* ✅ ADD HERE */}
    <DoerProgressModal
      email={progressEmail}
      open={progressOpen}
      onClose={() => setProgressOpen(false)}
    />
    </div>
  );



 
}


/* =================== GRID RENDERERS =================== */

function GridRenderer({
  department,
  grid,
  activeRow,
  onOpenSubmit,
  gridDateISO,
  canSubmitNow,
  allowedDates,
  mode,
   openUidPopup  
}) {
  const combined = Array.isArray(grid.Combined_StepWise_Table) ? grid.Combined_StepWise_Table : [];
  const indent = Array.isArray(grid.Indent_Stepwise_Grid) ? grid.Indent_Stepwise_Grid : [];
  const notDone = Array.isArray(grid.Not_Done_Level_Grid) ? grid.Not_Done_Level_Grid : [];
  const doneLate = Array.isArray(grid.DoneNotOnTime_Level_Grid) ? grid.DoneNotOnTime_Level_Grid : [];

  if ((department === "Accounts" || department === "Risk" || department === "HR" || department === "Dealing") && combined.length) {
    // ✅ NEW: per-process step columns (no global 15/55)
    return (
<PerProcessStepwiseGrid
  department={department}
  rows={combined}
  stepMeta={grid.stepMeta || {}}
  activeRow={activeRow}
  rowKey={grid.__rowKey || ""}
  onOpenSubmit={onOpenSubmit}
  gridDateISO={gridDateISO}
  canSubmitNow={canSubmitNow}
  allowedDates={allowedDates}
   mode={mode}
   openUidPopup={openUidPopup}
   
/>
    );
      }
   
    if ((department === "Inward" || department === "Outward") && indent.length) {
      return (
<IndentGridWithSubmit
  department={department}
  rows={indent}
  activeRow={activeRow}
  rowKey={grid.__rowKey || ""}
  onOpenSubmit={onOpenSubmit}
  gridDateISO={gridDateISO}
  canSubmitNow={canSubmitNow}
  allowedDates={allowedDates}
  mode={mode}
/>
      );
    }
    if (department === "Help Ticket") {
      return (
        <div style={{ display: "grid", gap: 14 }}>
          {notDone.length ? (
<HelpTicketGridWithSubmit
  title="Not Done Level Grid"
  department={department}
  rows={notDone}
  activeRow={activeRow}
  rowKey={grid.__rowKey || ""}
  onOpenSubmit={onOpenSubmit}
  gridDateISO={gridDateISO}
  canSubmitNow={canSubmitNow}
  allowedDates={allowedDates}
  mode={mode}
/>
          ) : null}
   
          {doneLate.length ? (
<HelpTicketGridWithSubmit
  title="Done Not OnTime Level Grid"
  department={department}
  rows={doneLate}
  activeRow={activeRow}
  rowKey={grid.__rowKey || ""}
  onOpenSubmit={onOpenSubmit}
  gridDateISO={gridDateISO}
  canSubmitNow={canSubmitNow}
  allowedDates={allowedDates}
    mode={mode}
/>
          ) : null}
{!notDone.length && !doneLate.length && combined.length ? (
  <PerProcessStepwiseGrid
    department={department}
    rows={combined}
    stepMeta={grid.stepMeta || {}}
    activeRow={activeRow}
    rowKey={grid.__rowKey || ""}
    onOpenSubmit={onOpenSubmit}
    gridDateISO={gridDateISO}
    canSubmitNow={canSubmitNow}
    allowedDates={allowedDates}
    openUidPopup={openUidPopup}
     mode={mode}
  />
) : null}

      {!notDone.length && !doneLate.length && !combined.length ? (
        <div className="mutedSmall">No grid data available for this row.</div>
      ) : null}
    </div>
  );
}
if (combined.length) return (
  <PerProcessStepwiseGrid
    department={department}
    rows={combined}
    stepMeta={grid.stepMeta || {}}
    activeRow={activeRow}
    rowKey={grid.__rowKey || ""}
    onOpenSubmit={onOpenSubmit}
    gridDateISO={gridDateISO}
    canSubmitNow={canSubmitNow}
    allowedDates={allowedDates}
    mode={mode}
    openUidPopup={openUidPopup}
  />
);
  if (indent.length) return <GenericObjectGrid title="Grid" rows={indent} />;

  return <div className="mutedSmall">No grid data available for this row.</div>;
}

// ✅ NEW: One mini-table per Process_Name with only needed steps
function buildKeys_(prefix, count) {
  const keys = [];
  const p = String(prefix || "T").toLowerCase();
  for (let i = 1; i <= Number(count || 0); i++) {
    if (p === "step") keys.push(`Step${i}`);
    else keys.push(`T${String(i).padStart(2, "0")}`);
  }
  return keys;
}

function normalizeProc_(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");
}

function pickDate_(r) {
  return (
    r.Date_Task||
    ""
  );
}

function fmtDate_(v) {
  if (!v) return "";
  // handle "YYYY-MM-DD" or timestamp-like
  const s = String(v);
  return s.length >= 10 ? s.slice(0, 10) : s;
}

function groupByProcess_(rows, department) {
  const m = new Map();

  rows.forEach((r) => {
    const rawDate = pickDate_(r);
    const dObj = rawDate ? new Date(rawDate) : null;

    // ❌ REMOVE weekend filtering completely

    const proc = safeStr(r.Process_Name || r.Process || r.FMS_Name || "Unknown");
    if (!m.has(proc)) m.set(proc, []);
    m.get(proc).push(r);
  });

  for (const arr of m.values()) {
    arr.sort((a, b) => {
      const da = new Date(pickDate_(a));
      const db = new Date(pickDate_(b));
      return da - db;
    });
  }

  return Array.from(m.entries()).map(([proc, list]) => ({ proc, list }));
}

function PerProcessStepwiseGrid({
  department,
  rows,
  stepMeta,
  activeRow,
  rowKey,
  onOpenSubmit,
  gridDateISO,
  canSubmitNow,
  allowedDates,
  mode,
  openUidPopup,
}) {
  const groups = groupByProcess_(rows, department);
const isDateAllowed = allowedDates.includes(String(gridDateISO || "").slice(0, 10));
const disableSubmit = !canSubmitNow || !isDateAllowed;
  return (
    <div className="processGridWrap">
      {groups.map(({ proc, list }, idx) => {
       const meta =
  stepMeta?.[normalizeProc_(proc)] ||
  null;

        let stepKeys = null;
        if (meta?.stepList?.length) {
          stepKeys = meta.stepList;
        } else if (meta?.stepCount) {
          stepKeys = buildKeys_(meta.stepPrefix || "T", meta.stepCount);
        } else {
          // fallback: detect from first row
          stepKeys = getStepKeysForSingleProcessRow_(list[0] || {});
        }

        const wide = stepKeys.length > 12;

        return (
          <div
            key={proc + "|" + idx}
            className={wide ? "processCard fullWidth" : "processCard"}
          >
<div className="processTitle">
  <div>{proc}</div>

  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
    <div className="processSteps">(Steps: {stepKeys.length})</div>

{mode === "pc" ? (
  <button
    className="btnGhost"
    type="button"
    disabled={disableSubmit}
    title={
      !canSubmitNow
        ? "Correction form can be submitted only between 08:00 AM and 12:00 PM IST"
        : !isDateAllowed
        ? `Allowed dates: ${allowedDates.join(", ")}`
        : "Submit correction"
    }
    onClick={() => {
      if (disableSubmit) return;

      const opts = extractPendingDelayedFromProcessRows(list);

      const pk = makeProcessKey({
        department,
        doerEmail: safeStr(activeRow?.User_Emails || ""),
        doerName: safeStr(activeRow?.User_Name || ""),
        processNameOrIndent: proc,
        date: gridDateISO,
      });

      onOpenSubmit?.({
        department,
        processKey: pk,
        gridDate: gridDateISO,
        doerName: safeStr(activeRow?.User_Name || ""),
        doerEmail: safeStr(activeRow?.User_Emails || ""),
        displayName: proc,
        taskOptions: opts,
      });
    }}
  >
    Submit
  </button>
) : null}

  </div>
</div>

            <div style={{ overflowX: "auto" }}>
              <table className="gridTable">
                <thead>
                  <tr>
                    <th className="dateCol">Date</th>
                    {stepKeys.map((k) => (
                      <th key={k}>{k}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {list.map((r, rIdx) => {
                    const d = fmtDate_(pickDate_(r));
                    return (
                      <tr key={proc + "|" + rIdx}>
                        <td className="dateCol">{d || "—"}</td>
                      {stepKeys.map((k) => {

  const v = safeStr(r[k] ?? "");

  // console.log(
  //   "STEP DEBUG",
  //   proc,
  //   k,
  //   v
  // );

  const cls = classifyCell_(v);

  return (
<td key={k} className={cls}>
 {renderStepCell(v, openUidPopup, department)}
</td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}

<div className="mutedSmall" style={{ marginTop: 4 }}>
  Legend:{" "}
  <span className="cellPlanned" style={{ padding: "2px 8px", borderRadius: 8 }}>
    P = Planned
  </span>{" "}
  <span className="cellDelay" style={{ padding: "2px 8px", borderRadius: 8 }}>
    D = Delay
  </span>
</div>
    </div>
  );
}

function getStepKeysForSingleProcessRow_(r) {
  // Collect Txx / Stepx keys
  const keys = Object.keys(r || {}).filter((k) => /^T\d+$/i.test(k) || /^Step\d+$/i.test(k));

  // Sort numeric
  keys.sort((a, b) => {
    const na = parseInt(a.replace(/\D/g, ""), 10);
    const nb = parseInt(b.replace(/\D/g, ""), 10);
    return na - nb;
  });

  // Find last meaningful step (not empty / not dash)
  let lastIdx = -1;
  for (let i = 0; i < keys.length; i++) {
    const v = safeStr(r[keys[i]]).trim();
    if (v && v !== "—" && v !== "-") lastIdx = i;
  }

  // If everything empty, show first few keys (fallback)
  const upto = lastIdx >= 0 ? lastIdx + 1 : Math.min(keys.length, 5);
  return keys.slice(0, upto);
}

function GenericObjectGrid({ title, rows }) {
  const cols = useMemo(() => {
    const set = new Set();
    rows.forEach((r) => Object.keys(r || {}).forEach((k) => set.add(k)));
    return Array.from(set);
  }, [rows]);

  return (
   
    <div>
      <div className="mutedSmall" style={{ marginBottom: 8, fontWeight: 800 }}>
        {title}
      </div>
      <div style={{ overflow: "auto" }}>
        <table className="gridTable">
          <thead>
            <tr>
              {cols.map((c) => (
                <th key={c}>{c}</th>
              ))}
            </tr>
          </thead>
<tbody>
  {rows.map((r, idx) => (
    <tr key={idx}>
      {cols.map((c) => {
        const val = safeStr(r?.[c]) || "—";
        const cls = classifyCell_(val); // ✅ APPLY COLOR LOGIC

        return (
          <td key={c} className={cls}>
            {val}
          </td>
        );
      })}
    </tr>
  ))}
</tbody>
        </table>
      </div>
    </div>
  );
}

function parseUIDsFromCell(v) {
  const text = String(v || "");
  const match = text.match(/\((.*?)\)/); // extract inside ()
  if (!match) return [];
  return match[1].split(",").map(s => s.trim());
}

function getShortLabel(v) {
  const text = String(v || "").toUpperCase();

  const dMatch = text.match(/(\d+)D/);
  if (dMatch) {
    return `${dMatch[1]}D`;
  }

  const pMatch = text.match(/(\d+)P/);
  if (pMatch) {
    return `${pMatch[1]}P`;
  }

  return "";
}
function renderStepCell(v, openUidPopup, department) {
  if (!v) return "";

  const text = String(v || "");
  const shortLabel = getShortLabel(v);

  // A Main_FMS-style cell is EXACTLY one of: "1P", "1D", "1P/1D",
  // optionally followed by "(Error)"/"(Adjusted)" — nothing else in
  // parens. HR/Help Ticket cells instead have real UIDs inside the
  // parens (e.g. "1P(abc-123, def-456)"). Testing the parenthetical
  // CONTENT itself (not just "does a match exist") tells them apart
  // reliably, even once the Error/Adjusted suffix is already present.
  const parenMatch = text.match(/\((.*?)\)/);
  const parenContent = parenMatch ? parenMatch[1].trim().toUpperCase() : null;
  const isMainFmsStyleCell = !parenMatch || parenContent === 'ERROR' || parenContent === 'ADJUSTED';

  const isPlainTextStyleDept =
    department === "Accounts" ||
    department === "Risk" ||
    department === "Dealing" ||
    isMainFmsStyleCell;

  if (isPlainTextStyleDept) {
    const isError = text.toUpperCase().includes("ERROR");
    return isError ? `${shortLabel}(Adjusted)` : shortLabel;
  }

  // ✅ Existing logic for HR / Help Ticket
  const uids = parseUIDsFromCell(v);

  if (!uids.length) return shortLabel;

  return (
    <span
      style={{
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 600
      }}
      onClick={(e) => {
        e.stopPropagation();
        openUidPopup(uids);
      }}
    >
      {shortLabel}
    </span>
  );
}
function classifyCell_(v) {
  const s = String(v || "").toUpperCase();

  // NA
  if (s.includes("NA") || s.includes("NOT APPLICABLE")) return "cellNA";

  // 🔴 DELAY (D) → RED TEXT
  if (/\d+D/.test(s) || s.includes("DELAY")) return "cellDelay";

  // 🟡 PLANNED (P) → YELLOW BG + RED TEXT
  if (/\d+P/.test(s) || s.includes("PLANNED")) return "cellPlanned";

  // Done (optional - keep if needed)
  if (s.includes("DONE") || s.includes("1D_DONE")) return "cellDone";

  // Not Done
  if (s.includes("ND") || s.includes("NOT DONE") || s.includes("0D")) return "cellND";

  return "";
}
function IndentGridWithSubmit({
  department,
  rows,
  activeRow,
  rowKey,
  onOpenSubmit,
  gridDateISO,
  canSubmitNow,
  allowedDates,
  mode,
}) {
  const indentKey = detectIndentFieldKey(rows?.[0]);
const isDateAllowed = allowedDates.includes(String(gridDateISO || "").slice(0, 10));
const disableSubmit = !canSubmitNow || !isDateAllowed;
  // group by indent number
  const groups = useMemo(() => {
    const m = new Map();
    (rows || []).forEach((r) => {
      const indentVal = safeStr(indentKey ? r?.[indentKey] : "");
      const key = indentVal || "UNKNOWN";
      if (!m.has(key)) m.set(key, []);
      m.get(key).push(r);
    });
    return Array.from(m.entries()).map(([indent, list]) => ({ indent, list }));
  }, [rows, indentKey]);

  return (
    <div style={{ display: "grid", gap: 14 }}>
     <div className="mutedSmall" style={{ marginTop: 6 }}>
  Legend:{" "}
  <span className="cellPlanned" style={{ padding: "2px 8px", borderRadius: 8 }}>
    P = Planned
  </span>{" "}
  <span className="cellDelay" style={{ padding: "2px 8px", borderRadius: 8 }}>
    D = Delay
  </span>
          </div>
      {groups.map(({ indent, list }, idx) => {
        const taskOptions = extractPendingDelayedTaskIdsFromIndentRows(list, indentKey);


const pk = makeProcessKey({
  department,
  doerEmail: safeStr(activeRow?.User_Emails || ""),
  doerName: safeStr(activeRow?.User_Name || ""),
  processNameOrIndent: String(indent || "Indent"),
  date: gridDateISO,
});
        return (
          <>
         
          <div key={indent + "|" + idx} className="processCard">
            <div className="processTitle">
              <div>{indentKey ? `${indentKey}: ${indent}` : `Indent: ${indent}`}</div>
{mode === "pc" ? (
  <button
    className="btnGhost"
    type="button"
    disabled={disableSubmit}
    title={
      !canSubmitNow
        ? "Correction form can be submitted only between 08:00 AM and 12:00 PM IST"
        : !isDateAllowed
        ? `Allowed dates: ${allowedDates.join(", ")}`
        : "Submit correction"
    }
    onClick={() => {
      if (disableSubmit) return;

      onOpenSubmit?.({
        department,
        processKey: pk,
        gridDate: gridDateISO,
        doerName: safeStr(activeRow?.User_Name || ""),
        doerEmail: safeStr(activeRow?.User_Emails || ""),
        displayName: String(indent || "Indent"),
        taskOptions,
      });
    }}
  >
    Submit
  </button>
) : null}
            </div>

            <GenericObjectGrid title="Indent Stepwise Grid" rows={list} />
          </div>
          </>
        );
      })}
    </div>
  );
}



function HelpTicketGridWithSubmit({
  title,
  department,
  rows,
  activeRow,
  rowKey,
  onOpenSubmit,
  gridDateISO,
  canSubmitNow,
  allowedDates,
  mode,
}) {
  const indentKey = detectIndentFieldKey(rows?.[0]);
const isDateAllowed = allowedDates.includes(String(gridDateISO || "").slice(0, 10));
const disableSubmit = !canSubmitNow || !isDateAllowed;
  const groups = useMemo(() => {
    const m = new Map();
    (rows || []).forEach((r) => {
      const indentVal = safeStr(indentKey ? r?.[indentKey] : "");
      const key = indentVal || "UNKNOWN";
      if (!m.has(key)) m.set(key, []);
      m.get(key).push(r);
    });
    return Array.from(m.entries()).map(([indent, list]) => ({ indent, list }));
  }, [rows, indentKey]);

  return (
    <div style={{ display: "grid", gap: 14 }}>
      <div className="mutedSmall" style={{ fontWeight: 900 }}>{title}</div>

      {groups.map(({ indent, list }, idx) => {
        const taskOptions = extractHelpTicketTaskIdsFromLevelRows(list, indentKey);

const pk = makeProcessKey({
  department,
  doerEmail: safeStr(activeRow?.User_Emails || ""),
  doerName: safeStr(activeRow?.User_Name || ""),
  processNameOrIndent: String(indent || "Indent"), // ✅ ONLY ticket/indent
  date: gridDateISO,
});
        return (
          <div key={indent + "|" + idx} className="processCard">
            <div className="processTitle">
              <div>{indentKey ? `${indentKey}: ${indent}` : `Indent: ${indent}`}</div>
{mode === "pc" ? (
  <button
    className="btnGhost"
    type="button"
    disabled={disableSubmit}
    title={
      !canSubmitNow
        ? "Correction form can be submitted only between 08:00 AM and 12:00 PM IST"
        : !isDateAllowed
        ? `Allowed dates: ${allowedDates.join(", ")}`
        : "Submit correction"
    }
    onClick={() => {
      if (disableSubmit) return;

      onOpenSubmit?.({
        department,
        processKey: pk,
        gridDate: gridDateISO,
        doerName: safeStr(activeRow?.User_Name || ""),
        doerEmail: safeStr(activeRow?.User_Emails || ""),
        displayName: String(indent || "Indent"),
        taskOptions,
      });
    }}
  >
    Submit
  </button>
) : null}
            </div>

            <GenericObjectGrid title={title} rows={list} />
          </div>
        );
      })}
    </div>
  );

 
}

// ====================== ✅ HELPERS for Submit Popup ======================

// ✅ For Accounts / Risk / HR / Dealing: TaskID = Step column (T01.. / Step1..)
// Return ONLY Pending/Delayed step codes from that process grid
function extractPendingDelayedFromProcessRows(processRows) {
  const out = new Set();

  (processRows || []).forEach((r) => {
    Object.keys(r || {}).forEach((k) => {
      if (!/^T\d+$/i.test(k) && !/^Step\d+$/i.test(k)) return;

      const v = String(r[k] || "").toUpperCase();

      // Pending OR Delayed only
      if (
  /\d+P/.test(v) ||
  /\d+D/.test(v) ||
  v.includes("PLANNED") ||
  v.includes("DELAY")
) {
  out.add(k);
}
    });
  });

  return Array.from(out).sort((a, b) => {
    const na = parseInt(a.replace(/\D/g, ""), 10);
    const nb = parseInt(b.replace(/\D/g, ""), 10);
    return na - nb;
  });
}

// ✅ For Inward/Outward/HelpTicket: find indent/unique key column name
function detectIndentFieldKey(row) {
  if (!row) return null;
  const keys = Object.keys(row);

  const candidates = [
    "Unique_ID", "unique_id",
    "Indent_Number", "indent_number",
    "IndentNumber", "indentNumber",
    "Indent_No", "indent_no",
    "Indent", "indent",
  ];
  for (const c of candidates) if (keys.includes(c)) return c;

  const guess = keys.find((k) => /indent|unique/i.test(k));
  return guess || null;
}

// ✅ For Indent grids: TaskID = column name (Stepcode columns)
// Return ONLY Pending/Delayed stepcodes from indent rows
function extractPendingDelayedTaskIdsFromIndentRows(indentRows, indentFieldKey) {
  const out = new Set();

  (indentRows || []).forEach((r) => {
    Object.keys(r || {}).forEach((k) => {
      if (k === indentFieldKey) return;
      if (/date/i.test(k)) return;

      const v = String(r[k] || "").toUpperCase();

      if (
        v.includes("1P") || v.includes("PLANNED") ||
        v.includes("1D") || v.includes("DELAY")
      ) {
        out.add(k); // ✅ Task ID = column name
      }
    });
  });

  return Array.from(out);
}
function extractHelpTicketTaskIdsFromLevelRows(levelRows, indentFieldKey) {
  const out = new Set();

  (levelRows || []).forEach((r) => {
    Object.keys(r || {}).forEach((k) => {
      if (k === indentFieldKey) return;
      if (/date/i.test(k)) return;

      const raw = safeStr(r?.[k]).trim();

      // If value exists and not dash → it is pending/delayed
      if (raw && raw !== "—" && raw !== "-") {
        out.add(k);  // ✅ return COLUMN NAME
      }
    });
  });

  return Array.from(out);
}

function makeProcessKey({ department, doerEmail, doerName, processNameOrIndent, date }) {
  return `${department}||${String(doerEmail || "").toLowerCase()}||${doerName}||${processNameOrIndent}||${date}`;
}
function getSubmissionsFromGroup(list) {
  return (list || []).flatMap((r) => (r?.Latest_Submissions || []));
}
function getSubmissionsFromRow(r) {
  // best case: backend gives list for each row
  if (Array.isArray(r?.Latest_Submissions) && r.Latest_Submissions.length) return r.Latest_Submissions;

  // fallback: backend gives single latest submission
  if (r?.Latest_Submission) return [r.Latest_Submission];

  return [];
}